/**
 * F60b — sidebar badge counts client.
 *
 *   GET /admin/nav-counts[?fresh=1] → get  { data: AdminNavCounts }
 *
 * Called only by `NavCountsProvider` (one poll a minute per visible tab, plus a
 * `fresh` read right after an admin action). The response holds only the keys
 * the admin's permissions allow. The vitest config aliases this module to
 * `navCounts.fixture`; the real request shape is pinned by
 * test/client-contracts-nav-counts.test.ts.
 */
import type { AdminNavCounts } from '@bravemove/types';
import { adminFetch, buildQuery } from '../auth/apiClient';

export interface NavCountsOpts {
  /** Skip the API's 15 s cache — used once right after an admin action. */
  readonly fresh?: boolean;
}

export const adminNavCountsApi = {
  get: async (opts: NavCountsOpts = {}): Promise<AdminNavCounts> => {
    const body = await adminFetch<{ readonly data: AdminNavCounts }>(
      `/admin/nav-counts${buildQuery({ fresh: opts.fresh ? '1' : undefined })}`,
    );
    return body.data;
  },
};
